<template>
    <div v-show="preloadPage"
         class="data-data"
    >
        <div class="container-fluid fluid-resolve">
            <div class="row center">
                <div class="logo-wraper"
                     v-bind:class="{bggray:preloadPage}"
                >
                    <div class="logo">
                        <img src="@/assets/images/logo-wpp.svg"/>
                    </div>
                    <div class="v-line"></div>
                    <div class="logo">
                        <img src="@/assets/images/logo-computa-blue.svg"/>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 center title">“Making everyone and every moment matter”</div>
            </div>

            <div class="row">

                <div class="col-lg-3 col-12">
                    <div class="item">
                        <div>
                            <div class="img-wrap">
                                <img class="bage-image" src="@/assets/images/svg/BagicSvg1.svg"/>
                            </div>
                            <div class="list">

                                <div class="line"><span>Name:</span> Michelle</div>
                                <div class="line"><span>Job title:</span> Data Scientist</div>
                                <div class="line"><span>Location:</span> UK<img
                                                                                src="@/assets/images/icons/flag_uk.png"/>
                                </div>
                                <div class="line"><span>User Scenario:</span> New joiner</div>
                            </div>
                            <div class="subtitle">“I hope my first day is welcoming”</div>
                            <div class="description">
                                Michelle has been offered her dream job with WPP. She’s not sure where to start or what
                                to
                                do on her first day, though she is really keen to help everyone and do her best. She
                                recalls her
                                last employer not being very organised supporting new starters.
                            </div>
                        </div>
                        <div class="link-wrap">
                            <div class="link start  d-lg-none" @click="toInnerEnvironment('reception')">Start my journey</div>
                            <div class="link start d-none d-lg-flex" @click="goStart">Start my journey</div>
                            <a href="https://www.computacenter.com/docs/default-source/wpp/wavy1.pdf"  target="_blank" class="link dwnload">Download my journey</a>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-12">
                    <div class="item">
                        <div>
                            <div class="img-wrap">
                                <img class="bage-image" src="@/assets/images/svg/BagicSvg2.svg"/>
                            </div>
                            <div class="list">

                                <div class="line"><span>Name:</span> Maria</div>
                                <div class="line"><span>Job title:</span>Account Manager</div>
                                <div class="line"><span>Location:</span> Brazil<img
                                                                                    src="@/assets/images/icons/flag_2.png"/>
                                </div>
                                <div class="line"><span>User Scenario:</span> Rock the Tech Hub</div>
                            </div>
                            <div class="subtitle">“I need a Tech Hub visit to help fix my laptop – I need options to
                                engage”
                            </div>
                            <div class="description">
                                Maria has a problem with her laptop webcam. Her nearest Tech Hub is a 15 minute walk,
                                whilst
                                currently busy on a Teams call she needs to engage via a different channel, she would
                                like to
                                use the chat function within Teams, enabling a seamless experience.
                            </div>
                        </div>
                        <div class="link-wrap">
                            <div class="link start color-pink  d-lg-none" @click="toInnerEnvironment('tech-bar')">Start my journey</div>
                            <div class="link start color-pink d-none d-lg-flex" @click="goStart">Start my journey</div>
                            <a  href="https://www.computacenter.com/docs/default-source/wpp/wavy2.pdf"  target="_blank"  class="link dwnload">Download my journey</a>
                        </div>
                    </div>
                </div>


                <div class="col-lg-3 col-12">
                    <div class="item">
                        <div>
                            <div class="img-wrap">
                                <img class="bage-image" src="@/assets/images/svg/BagicSvg3.svg"/>
                            </div>
                            <div class="list">

                                <div class="line"><span>Name:</span> Li</div>
                                <div class="line"><span>Job title:</span>Campaign Manager</div>
                                <div class="line"><span>Location:</span>China<img
                                                                                  src="@/assets/images/icons/flag_3.png"/>
                                </div>
                                <div class="line"><span>User Scenario:</span>Month End Visibility</div>
                            </div>
                            <div class="subtitle">“It’s Month End – I hope my device doesn’t fail as I’ve no local
                                support”
                            </div>
                            <div class="description">
                                Li is working on his Windows device on the Month End Reports. As he works alone in a
                                small
                                office, he is nervous that Group IT cannot support him in the event of a hardware
                                failure. His
                                device has had a catastrophic hardware error, background analytic engines identify Li’s
                                device
                                has failed.
                            </div>
                        </div>
                        <div class="link-wrap">
                            <a  href="https://www.computacenter.com/docs/default-source/wpp/wavy3.pdf"  target="_blank"  class="link dwnload">Download my journey</a>
                        </div>
                    </div>
                </div>


                <div class="col-lg-3 col-12">
                    <div class="item">
                        <div>
                            <div class="img-wrap">
                                <img class="bage-image" src="@/assets/images/svg/BagicSvg4.svg"/>
                            </div>
                            <div class="list">

                                <div class="line"><span>Name:</span>Elijah</div>
                                <div class="line"><span>Job title:</span>Creative Director</div>
                                <div class="line"><span>Location:</span> US<img
                                                                                src="@/assets/images/icons/flag_4.png"/>
                                </div>
                                <div class="line"><span>User Scenario:</span>Agile and Client Collaboration</div>
                            </div>
                            <div class="subtitle">“Following an acquisition, I need to mobilise a team to work across
                                WPP &
                                partner agencies”
                            </div>
                            <div class="description">
                                Elijah needs to work on an urgent media project for a new customer with a partner
                                organisation
                                WPP have just acquired. There are a lot of documents already in existence, they and
                                their team
                                need to review and get up to speed quickly from various locations.
                                <br>
                                They also need to collaborate across disparate IT systems with the newly acquired
                                partner.
                            </div>
                        </div>
                        <div class="link-wrap">
                            <a  href="https://www.computacenter.com/docs/default-source/wpp/wavy4.pdf"  target="_blank"  class="link dwnload">Download my journey</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <div class="container-fluid  foot">
            <div class="col-12">
                <div class="">©2016 - 2022 Computacenter (UK) Ltd</div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapGetters} from 'vuex'


    export default {
        name: 'Frontpage',
        components: {},
        data() {
            return {}
        },

        computed: {
            ...mapGetters({
                environments: 'environments/environments',
                preloadPage: 'environments/preloadPage',
            })
        },
        methods: {
            toInnerEnvironment(slug){
                this.$store.dispatch('environments/setBgImage', this.subdir+'/images/environments/'+slug+'.jpg');
                this.$store.dispatch('environments/setActiveEnvSlug', slug);

                this.$emit('setActiveEnv', this.getEnvDBid(slug))
                console.log('slug',slug)
                setTimeout(() => {
                    this.$router.push({name: 'Environments'});
                }, 100)
            },
            toEnvironment(){
                this.$store.dispatch('environments/setFrontPagePreload', false);
                this.$emit('toEnvironment')
            },
            goStart() {
                this.$store.dispatch('environments/setFrontPagePreload', false);
                console.log('goStart');
            },

            getEnvDBid(slug) {
                let sl = 1;
                // console.log('environments:',this.environments)
                sl = this.environments.find((item) => {
                    return item.slug == slug;
                });
                return sl.id;
            },
        }

    }
</script>